import { RecommendationSubtitleResponse } from "../../types/subscribtios";
import { FAST_API_URL } from "../index";
import { GetRecommendationArgs, SyntAudioArgs } from "./types";

export const getTranslatedSubtitleRecommendsApi = async ({
  mediaId,
  lang,
  metasubtitle_id,
  folder_num,
  language_from,
}: SyntAudioArgs): Promise<RecommendationSubtitleResponse> => {
  const response = await fetch(
    `${FAST_API_URL}/get_translated_subtitle_recommends?media=${mediaId}&lang=${lang}&metasubtitle_id=${metasubtitle_id}&folder_num=${folder_num}&language_from=${language_from || ''}`,
  );
  if (!response.ok) {
    throw new Error("cant get translated subtitle recommendation");
  }
  return await response.json();
};

export const getSubtitleRecommendsApi = async ({
  mediaId,
  lang,
  metasubtitle_id,
  folder_num,
  variants,
  synonyms,
  language_from,
}: GetRecommendationArgs): Promise<RecommendationSubtitleResponse> => {
  const params = new URLSearchParams({
    media: mediaId,
    lang,
    metasubtitle_id,
    folder: folder_num.toString(),
    variants: variants.toString(),
    synonyms: synonyms.toString(),
  });
  if (language_from) {
    params.append('language_from', language_from);
  }
  const response = await fetch(`${FAST_API_URL}/get_recommend?${params.toString()}`);
  if (!response.ok) {
    throw new Error("cant get subtitle recommendation");
  }
  return await response.json();
};
